module.exports = __webpack_public_path__ + "img/banner-5.5a1c1b86.jpg";